// extracted by mini-css-extract-plugin
module.exports = {"container":"browserScreenWithIPhone-module--container--3ZbwH","browser":"browserScreenWithIPhone-module--browser--1JUp6","phone":"browserScreenWithIPhone-module--phone--3dQto"};